import { DocumentTypeEnum } from "../../templates/template.dto";
import { DocumentStatusesEnum } from "../dto/document-statuses.enum";

export const documentActions = (componentInstance) => [
    {
        key: 'fullscreen',
        icon: 'icon-maximize',
        textKey: 'Fullscreen text for document link (Documents Section) - Fullscreen',
        click: componentInstance.openFullScreen.bind(componentInstance), // Method to be called on click
        class: 'sort-asc',
        showIf: () => true, // Always visible
    },
    {
        key: 'SendRemindertoAll',
        icon: 'icon-clock',
        textKey: 'Send Reminder to All text for open modal (Documents Section) - Send Reminder to All',
        click: componentInstance.SendRemindertoAll.bind(componentInstance),
        class: 'sort-asc hidden',
        showIf: (doc) => doc?.template?.status !== DocumentStatusesEnum.Rejected,
        disabledIf: (permissions) => permissions?.canEditDocument === false,
    },
    {
        key: 'internalReminder',
        icon: 'icon-calendar',
        textKey: 'Internal reminder text for open modal (Documents Section) - Internal reminder',
        click: componentInstance.internalReminderClick.bind(componentInstance),
        class: 'sort-asc',
        showIf: (doc) => doc?.template?.status !== DocumentStatusesEnum.Rejected,
        disabledIf: (permissions) => permissions?.canEditDocument === false,
    },
    {
        key: 'edit',
        icon: 'icon-edit',
        textKey: 'Edit document text for button (Documents Section) - Edit document',
        click: componentInstance.editDocument.bind(componentInstance),
        class: 'sort-asc',
        showIf: (doc) => (!doc?.template_details?.is_uploaded &&
            ![DocumentStatusesEnum.Uploaded, DocumentStatusesEnum.Signed, DocumentStatusesEnum.Rejected, DocumentStatusesEnum.Completed].includes(doc?.template?.status) || doc?.template_details?.type === DocumentTypeEnum.TEMPLATEDOCUMENT),
        disabledIf: (permissions) => !permissions?.canEditSendDocument || !permissions?.canEditDocument,
    },
    {
        key: 'resend',
        icon: 'icon-refresh-ccw',
        textKey: 'Resend Document text for button (Documents Section) - Resend Document',
        click: componentInstance.resendDocument.bind(componentInstance),
        class: 'sort-asc',
        showIf: (doc) => !doc?.template_details?.is_uploaded &&
            ![DocumentStatusesEnum.Draft, DocumentStatusesEnum.Uploaded].includes(doc?.template?.status) && doc?.template_details?.type !== DocumentTypeEnum.TEMPLATEDOCUMENT,
        disabledIf: (permissions) => permissions?.resendLoader || permissions?.canResendDocument === false || permissions?.canEditDocument === false,
    },
    {
        key: 'indexData',
        icon: 'me-50 icon-database',
        textKey: 'Index data text for button (Documents Section) - Index data',
        click: componentInstance.openIndexDataModal.bind(componentInstance),
        class: 'sort-asc',
        showIf: (doc) => !doc?.template_details?.is_uploaded &&
            ![DocumentStatusesEnum.Draft, DocumentStatusesEnum.Uploaded].includes(doc?.template?.status),
        disabledIf: () => false,
    },
    {
        key: 'revoke',
        icon: 'icon-x-circle',
        textKey: 'Revoke text for button (Documents Section) - Revoke',
        click: componentInstance.revokeDocument.bind(componentInstance),
        class: 'sort-asc',
        showIf: (doc) => !doc?.template_details?.is_uploaded &&
            [DocumentStatusesEnum.Sent, DocumentStatusesEnum.Delivered, DocumentStatusesEnum.Viewed].includes(doc?.template?.status),
        disabledIf: (permissions) => permissions?.canRevokeDocument === false || permissions?.canEditDocument === false,
    },
    {
        key: 'download',
        icon: 'icon-download',
        textKey: 'PDF text for button (Documents Section) - PDF',
        click: componentInstance.downloadPDF.bind(componentInstance),
        class: 'sort-asc',
        showIf: (doc) => ![DocumentStatusesEnum.Draft].includes(doc?.template?.status),
        disabledIf: (permissions) => permissions?.canDownloadDocument === false,
    },
    {
        key: 'deletePermanently',
        icon: 'icon-trash',
        textKey: 'Delete permanently text for button (Documents Section) - Delete permanently',
        click: componentInstance.deleteDocumentPermanently.bind(componentInstance),
        class: 'sort-asc',
        showIf: (doc, permissions) => permissions?.canDeleteDocumentPermanently,
        disabledIf: (permissions, doc) => permissions?.canDeletedSignedDocument === false &&
            [DocumentStatusesEnum.Signed, DocumentStatusesEnum.Completed].includes(doc?.template?.status) || permissions?.canEditDocument === false,
    },
    {
        key: 'moveToTrash',
        icon: 'icon-trash',
        textKey: 'Move to trash text for button (Documents Section) - Move to trash',
        click: componentInstance.moveToTrash.bind(componentInstance),
        class: 'sort-asc text-danger',
        showIf: (doc, permissions) => permissions?.canSoftDeleteDocument,
        disabledIf: (permissions, doc) => permissions?.canDeletedSignedDocument === false &&
            [DocumentStatusesEnum.Signed, DocumentStatusesEnum.Completed].includes(doc?.template?.status) || permissions?.canEditDocument === false,
    },
    {
        key: 'metodikaResend',
        icon: 'icon-upload',
        textKey: 'Send to metodika again button text (Documents Section) - Re-upload to Metodika',
        click: componentInstance.sendToMetodikaAgain.bind(componentInstance),
        class: 'sort-asc',
        showIf: () => componentInstance.specialAction === 'metodika',
        disabledIf: () => componentInstance.isResendingToMetodika,
    }
];
